import { formatDateTime } from './client-diff';

// Logic of the "Documentation" block of the "Clés API" tab, kept out of any component.

/** Reminder shown under the password: it only exists in plain text while it is being generated. */
/**
 * Removes the slashes at the end of a text. A loop and not a regex such as /\/+$/: a repetition anchored
 * at the end backtracks in quadratic time on a long run of slashes.
 */
const trimTrailingSlashes = (text) => {
  let end = text.length;

  while (end > 0 && text[end - 1] === '/') end -= 1;

  return text.slice(0, end);
};

export const DOCS_LOGIN_HINT =
  'Le mot de passe n’est conservé que sous forme d’empreinte : il ne sera plus jamais affiché. S’il est perdu, régénérez-en un.';

/**
 * Address to give the client so they can read the documentation: the API root (the front end's
 * REACT_APP_BASE_URL variable) followed by the path provided by the API. Without the variable, the
 * address of the page. Any path in the API address is ignored: the documentation is served at the
 * root of the server.
 *
 * @param {string|undefined} apiBaseUrl
 * @param {string} docsPath - E.g. "/api/docs"
 * @param {string} pageOrigin - Page address, used when no API address is set (injectable for tests)
 */
export const buildDocsUrl = (
  apiBaseUrl,
  docsPath,
  pageOrigin = typeof window === 'undefined' ? '' : window.location.origin
) => {
  const origin = apiBaseUrl || pageOrigin;

  try {
    return new URL(docsPath, origin).href;
  } catch {
    return `${trimTrailingSlashes(origin)}${docsPath}`;
  }
};

/** "Mot de passe généré le 22/10/2026 14:30 par Camille", or '' if there has never been one. */
export const describePasswordGeneration = (access) => {
  if (!access.password_generated_at) return '';

  const author = access.password_generated_by?.name;

  const by = author ? ` par ${author}` : '';

  return `Mot de passe généré le ${formatDateTime(access.password_generated_at)}${by}`;
};
